{
  "about.blocks": "Prižiūrimi serveriai",
  "about.contact": "Kontaktai:",
  "about.default_locale": "Numatyta",
  "about.disclaimer": "„Mastodon“ – tai nemokama atvirojo kodo programinė įranga ir „Mastodon gGmbH“ prekės ženklas.",
  "about.domain_blocks.no_reason_available": "Priežastis nepateikta",
  "about.domain_blocks.preamble": "„Mastodon“ paprastai leidžia peržiūrėti turinį ir bendrauti su naudotojais iš bet kurio kito fediverse esančio serverio. Šios yra išimtys, kurios buvo padarytos šiame konkrečiame serveryje.",
  "about.domain_blocks.silenced.explanation": "Paprastai nematysi profilių ir turinio iš šio serverio, nebent jį aiškiai ieškosi arba pasirinksi jį sekant.",
  "about.domain_blocks.silenced.title": "Apribota",
  "about.domain_blocks.suspended.explanation": "Jokie duomenys iš šio serverio nebus apdorojami, saugomi ar keičiami, todėl bet kokia sąveika ar bendravimas su šio serverio naudotojais bus neįmanomas.",
  "about.domain_blocks.suspended.title": "Pristabdyta",
  "about.language_label": "Kalba",
  "about.not_available": "Ši informacija nebuvo pateikta šiame serveryje.",
  "about.powered_by": "Decentralizuota socialinė medija, veikianti pagal „{mastodon}“",
  "about.rules": "Serverio taisyklės",
  "account.account_note_header": "Asmeninė pastaba",
  "account.activity": "Veikla",
  "account.add_note": "Pridėti asmeninę pastabą",
  "account.add_or_remove_from_list": "Įtraukti arba šalinti iš sąrašų",
  "account.badges.admin": "Administratorius",
  "account.badges.blocked": "Užblokuota",
  "account.badges.bot": "Automatizuotas",
  "account.badges.domain_blocked": "Užblokuoti serveriai",
  "account.badges.group": "Grupė",
  "account.badges.muted": "Nutildytas",
  "account.block": "Blokuoti @{name}",
  "account.block_domain": "Blokuoti serverį {domain}",
  "account.block_short": "Blokuoti",
  "account.blocked": "Užblokuota",
  "account.cancel_follow_request": "Atšaukti sekimą",
  "account.copy": "Kopijuoti nuorodą į profilį",
  "account.direct": "Privačiai paminėti @{name}",
  "account.disable_notifications": "Nustoti man pranešti, kai @{name} paskelbia",
  "account.edit_note": "Redaguoti asmeninę pastabą",
  "account.edit_profile": "Redaguoti profilį",
  "account.edit_profile_short": "Redaguoti",
  "account.enable_notifications": "Pranešti man, kai @{name} paskelbia",
  "account.endorse": "Rodyti profilyje",
  "account.familiar_followers_many": "Sekama {name1}, {name2}, ir {othersCount, plural, one {dar vieno} few {# dar keleto} many {# dar kelių} other {# kitų pažystąmų}}",
  "account.familiar_followers_one": "Seka {name1}",
  "account.familiar_followers_two": "{name1} ir {name2} seka",
  "account.featured": "Rodomi",
  "account.featured.accounts": "Profiliai",
  "account.filters.all": "Visa veikla",
  "account.filters.boosts_toggle": "Rodyti pasidalinimus",
  "account.filters.posts_boosts": "Įrašai ir pasidalinimai",
  "account.filters.posts_only": "Įrašai",
  "account.filters.replies_toggle": "rodyti atsakymus",
  "account.follow": "Sekti",
  "account.follow_back": "Sekti atgal",
  "account.follow_back_short": "Sekti atgal",
  "account.follow_request": "Prašymas sekti",
  "account.follow_request_cancel": "Atšaukti prašymą",
  "account.follow_request_cancel_short": "Atšaukti",
  "account.follow_request_short": "Prašymas",
  "account.followers": "Sekėjai",
  "account.followers.empty": "Šio naudotojo dar niekas neseka.",
  "account.followers_counter": "{count, plural, one {{counter} sekėjas} few {{counter} sekėjai} many {{counter} sekėjo} other {{counter} sekėjų}}",
  "account.followers_you_know_counter": "{counter} žinomas",
  "account.following": "Sekama",
  "account.following_counter": "{count, plural, one {{counter} seka} few {{counter} seka} many {{counter} seka} other {{counter} seka}}",
  "account.follows.empty": "Šis naudotojas dar nieko neseka.",
  "account.follows_you": "Seka tave",
  "account.go_to_profile": "Eiti į profilį",
  "account.hide_reblogs": "Slėpti pasidalinimus iš @{name}",
  "account.in_memoriam": "Atminimui.",
  "account.joined_short": "Prisijungė",
  "account.languages": "Keisti prenumeruojamas kalbas",
  "account.link_verified_on": "Šios nuorodos nuosavybė buvo patikrinta {date}",
  "account.locked_info": "Šios paskyros privatumo būsena nustatyta kaip užrakinta. Savininkas (-ė) rankiniu būdu peržiūri, kas gali sekti.",
  "account.media": "Medija",
  "account.mention": "Paminėti @{name}",
  "account.moved_to": "{name} nurodė, kad dabar jų nauja paskyra yra:",
  "account.mute": "Nutildyti @{name}",
  "account.mute_notifications_short": "Nutildyti pranešimus",
  "account.mute_short": "Nutildyti",
  "account.muted": "Nutildytas",
  "account.mutual": "Sekate vienas kitą",
  "account.no_bio": "Nėra pateikto aprašymo.",
  "account.node_modal.callout": "Asmeninės pastabos matomos tik jums.",
  "account.node_modal.edit_title": "Redaguoti asmeninę pastabą",
  "account.node_modal.error_unknown": "Nepavyko išsaugoti pastabos",
  "account.node_modal.field_label": "Asmeninė pastaba",
  "account.node_modal.save": "Išsaugoti",
  "account.node_modal.title": "Pridėti asmeninę pastabą",
  "account.note.edit_button": "Redaguoti",
  "account.note.title": "Asmeninės pastabos (matomos tik jums)",
  "account.open_original_page": "Atidaryti originalų puslapį",
  "account.posts": "Įrašai",
  "account.remove_from_followers": "Šalinti {name} iš sekėjų",
  "account.report": "Pranešti apie @{name}",
  "account.requested_follow": "{name} paprašė tave sekti",
  "account.share": "Bendrinti @{name} profilį",
  "account.show_reblogs": "Rodyti pasidalinimus iš @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} įrašas} few {{counter} įrašai} many {{counter} įrašo} other {{counter} įrašų}}",
  "account.unblock": "Atblokuoti @{name}",
  "account.unblock_domain": "Atblokuoti serverį {domain}",
  "account.unblock_domain_short": "Atblokuoti",
  "account.unblock_short": "Atblokuoti",
  "account.unendorse": "Nerodyti profilyje",
  "account.unfollow": "Nebesekti",
  "account.unmute": "Atšaukti nutildymą @{name}",
  "account.unmute_notifications_short": "Atšaukti pranešimų nutildymą",
  "account.unmute_short": "Atšaukti nutildymą",
  "account_note.placeholder": "Spustelėk, kad pridėtum pastabą.",
  "admin.dashboard.daily_retention": "Naudotojų pasilikimo rodiklis pagal dieną po registracijos",
  "admin.dashboard.monthly_retention": "Naudotojų pasilikimo rodiklis pagal mėnesį po registracijos",
  "admin.dashboard.retention.average": "Vidurkis",
  "admin.dashboard.retention.cohort": "Registracijos mėnuo",
  "admin.dashboard.retention.cohort_size": "Nauji naudotojai",
  "admin.impact_report.instance_accounts": "Paskyrų profiliai, kuriuos tai ištrintų",
  "admin.impact_report.instance_followers": "Sekėjai, kuriuos prarastų mūsų naudotojai",
  "admin.impact_report.instance_follows": "Sekėjai, kuriuos prarastų jų naudotojai",
  "admin.impact_report.title": "Poveikio apibendrinimas",
  "alert.rate_limited.message": "Bandyk vėl po {retry_time, time, medium}.",
  "alert.rate_limited.title": "Sparta apribota.",
  "alert.unexpected.message": "Įvyko netikėta klaida.",
  "alert.unexpected.title": "Ups!",
  "alt_text_badge.title": "Alternatyvus tekstas",
  "alt_text_modal.add_alt_text": "Pridėti alternatyvųjį tekstą",
  "alt_text_modal.add_text_from_image": "Pridėti tekstą iš vaizdo",
  "alt_text_modal.cancel": "Atšaukti",
  "alt_text_modal.change_thumbnail": "Keisti miniatiūrą",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Aprašykite tai klausos negalią turintiems asmenims…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Aprašykite tai regos sutrikimų turintiems asmenims…",
  "alt_text_modal.done": "Atlikta",
  "announcement.announcement": "Skelbimas",
  "annual_report.announcement.action_build": "Sukurti mano Wrapstodon",
  "annual_report.announcement.action_dismiss": "Ne, ačiū",
  "annual_report.announcement.action_view": "Peržiūrėti mano Wrapstodon",
  "annual_report.announcement.description": "Sužinokite daugiau apie savo aktyvumą Mastodon\"e per pastaruosius metus.",
  "annual_report.announcement.title": "Wrapstodon {year} jau čia",
  "annual_report.nav_item.badge": "Nauja",
  "annual_report.shared_page.donate": "Paremti",
  "annual_report.shared_page.footer": "Sukurta su {heart} Mastodon komandos",
  "annual_report.shared_page.footer_server_info": "{username} naudoja {domain}, vieną iš daugelio bendruomenių, kurios veikia „Mastodon“ dėka.",
  "annual_report.summary.archetype.booster.desc_public": "{name} tęsė ieškojimus, kokiais įrašais pasidalinti, kad padėtų kitiems kūrėjams pasiekti puikių rezultatų.",
  "annual_report.summary.archetype.booster.desc_self": "Tu nuolat ieškojai įrašų, kurais galėtum pasidalinti, tuo puikiai padėdamas kitiems kūrėjams.",
  "annual_report.summary.archetype.booster.name": "Lankininkas",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.close": "Užverti",
  "annual_report.summary.highlighted_post.title": "Populiariausi įrašai",
  "annual_report.summary.most_used_app.most_used_app": "labiausiai naudota programa",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "labiausiai naudota grotažymė",
  "annual_report.summary.new_posts.new_posts": "nauji įrašai",
  "annual_report.summary.percentile.text": "<topLabel>Tai reiškia, kad esate tarp</topLabel><percentage></percentage><bottomLabel>populiariausių {domain} naudotojų.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Mes nesakysime Bernie.",
  "annual_report.summary.share_message": "Aš gavau „{archetype}“!",
  "attachments_list.unprocessed": "(neapdorotas)",
  "audio.hide": "Slėpti garsą",
  "block_modal.remote_users_caveat": "Paprašysime serverio {domain} gerbti tavo sprendimą. Tačiau atitiktis negarantuojama, nes kai kurie serveriai gali skirtingai tvarkyti blokavimus. Vieši įrašai vis tiek gali būti matomi neprisijungusiems naudotojams.",
  "block_modal.show_less": "Rodyti mažiau",
  "block_modal.show_more": "Rodyti daugiau",
  "block_modal.they_will_know": "Jie gali matyti, kad yra užblokuoti.",
  "block_modal.title": "Blokuoti naudotoją?",
  "boost_modal.combo": "Galima paspausti {combo}, kad praleisti tai kitą kartą",
  "boost_modal.reblog": "Pasidalinti įrašą?",
  "boost_modal.undo_reblog": "Nebepasidalinti įrašo?",
  "bundle_column_error.copy_stacktrace": "Kopijuoti klaidos ataskaitą",
  "bundle_column_error.error.body": "Paprašytos puslapio nepavyko atvaizduoti. Tai gali būti dėl mūsų kodo klaidos arba naršyklės suderinamumo problemos.",
  "bundle_column_error.error.title": "O, ne!",
  "bundle_column_error.network.body": "Bandant užkrauti šį puslapį įvyko klaida. Tai galėjo atsitikti dėl laikinos tavo interneto ryšio arba šio serverio problemos.",
  "bundle_column_error.network.title": "Tinklo klaida",
  "bundle_column_error.retry": "Bandyti dar kartą",
  "bundle_column_error.return": "Atgal į pagrindinį",
  "bundle_column_error.routing.body": "Paprašyto puslapio nepavyko rasti. Ar esi tikras (-a), kad adreso juostoje nurodytas URL adresas yra teisingas?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Uždaryti",
  "bundle_modal_error.message": "Įkeliant šį ekraną kažkas nutiko ne taip.",
  "bundle_modal_error.retry": "Bandyti dar kartą",
  "carousel.current": "<sr>Skirtukas</sr> {current, number} / {max, number}",
  "carousel.slide": "Rodoma {current, number} iš {max, number}",
  "closed_registrations.other_server_instructions": "Kadangi „Mastodon“ yra decentralizuotas, gali susikurti paskyrą kitame serveryje ir vis tiek bendrauti su šiuo serveriu.",
  "closed_registrations_modal.description": "Sukurti paskyrą serveryje {domain} šiuo metu neįmanoma, bet nepamiršk, kad norint naudotis „Mastodon“ nebūtina turėti paskyrą serveryje {domain}.",
  "closed_registrations_modal.find_another_server": "Rasti kitą serverį",
  "closed_registrations_modal.preamble": "„Mastodon“ yra decentralizuotas, todėl nesvarbu, kur susikursi paskyrą, galėsi sekti ir bendrauti su bet kuriuo šiame serveryje esančiu asmeniu. Jį gali net savarankiškai talpinti!",
  "closed_registrations_modal.title": "Užsiregistruoti platformoje „Mastodon“",
  "column.about": "Apie",
  "column.blocks": "Užblokuoti naudotojai",
  "column.bookmarks": "Žymės",
  "column.community": "Vietinė laiko skalė",
  "column.create_list": "Kurti sąrašą",
  "column.direct": "Paminėjimai",
  "column.directory": "Naršyti profilius",
  "column.domain_blocks": "Užblokuoti serveriai",
  "column.edit_list": "Redaguoti sąrašą",
  "column.favourites": "Mėgstami",
  "column.firehose": "Tiesioginiai srautai",
  "column.firehose_local": "Tiesioginis srautas iš šio serverio",
  "column.firehose_singular": "Tiesioginis srautas",
  "column.follow_requests": "Sekimo prašymai",
  "column.home": "Pagrindinis",
  "column.list_members": "Tvarkyti sąrašo narius",
  "column.lists": "Sąrašai",
  "column.mutes": "Nutildyti naudotojai",
  "column.notifications": "Pranešimai",
  "column.pins": "Prisegti įrašai",
  "column.public": "Federacinė laiko skalė",
  "column_back_button.label": "Atgal",
  "column_header.hide_settings": "Slėpti nustatymus",
  "column_header.moveLeft_settings": "Perkelti stulpelį į kairę",
  "column_header.moveRight_settings": "Perkelti stulpelį į dešinę",
  "column_header.pin": "Prisegti",
  "column_header.show_settings": "Rodyti nustatymus",
  "column_header.unpin": "Atsegti",
  "column_search.cancel": "Atšaukti",
  "community.column_settings.local_only": "Tik vietinis",
  "community.column_settings.media_only": "Tik medija",
  "community.column_settings.remote_only": "Tik nuotolinis",
  "compose.error.blank_post": "Įrašas negali būti tuščias.",
  "compose.language.change": "Keisti kalbą",
  "compose.language.search": "Ieškoti kalbų...",
  "compose.published.body": "Įrašas paskelbtas.",
  "compose.published.open": "Atidaryti",
  "compose.saved.body": "Įrašas išsaugotas.",
  "compose_form.direct_message_warning_learn_more": "Sužinoti daugiau",
  "compose_form.encryption_warning": "„Mastodon“ įrašai nėra visapusiškai šifruojami. Per „Mastodon“ nesidalyk jokia slapta informacija.",
  "compose_form.hashtag_warning": "Šis įrašas nebus įtrauktas į jokį grotažodį, nes jis nėra viešas. Tik vieši įrašai gali būti ieškomi pagal grotažymę.",
  "compose_form.lock_disclaimer": "Tavo paskyra nėra {locked}. Bet kas gali sekti tave ir peržiūrėti tik sekėjams skirtus įrašus.",
  "compose_form.lock_disclaimer.lock": "užrakinta",
  "compose_form.placeholder": "Kas tavo mintyse?",
  "compose_form.poll.duration": "Apklausos trukmė",
  "compose_form.poll.multiple": "Keli pasirinkimai",
  "compose_form.poll.option_placeholder": "{number} parinktis",
  "compose_form.poll.single": "Vienas pasirinkimas",
  "compose_form.poll.switch_to_multiple": "Keisti apklausą, kad būtų leidžiama pasirinkti kelis pasirinkimus",
  "compose_form.poll.switch_to_single": "Keisti apklausą, kad būtų leidžiama pasirinkti vieną pasirinkimą",
  "compose_form.poll.type": "Stilius",
  "compose_form.publish": "Skelbti",
  "compose_form.reply": "Atsakyti",
  "compose_form.save_changes": "Atnaujinti",
  "compose_form.spoiler.marked": "Pašalinti turinio įspėjimą",
  "compose_form.spoiler.unmarked": "Pridėti turinio įspėjimą",
  "compose_form.spoiler_placeholder": "Turinio įspėjimas (pasirinktinis)",
  "confirmation_modal.cancel": "Atšaukti",
  "confirmations.block.confirm": "Blokuoti",
  "confirmations.delete.confirm": "Ištrinti",
  "confirmations.delete.message": "Ar tikrai nori ištrinti šį įrašą?",
  "confirmations.delete.title": "Ištrinti įrašą?",
  "confirmations.delete_list.confirm": "Ištrinti",
  "confirmations.delete_list.message": "Ar tikrai nori negrįžtamai ištrinti šį sąrašą?",
  "confirmations.delete_list.title": "Ištrinti sąrašą?",
  "confirmations.discard_draft.confirm": "Išsaugoti ir tęsti",
  "confirmations.discard_draft.edit.cancel": "Tęsti redagavimą",
  "confirmations.discard_draft.edit.message": "Tęsdami, jūs prarasite visus pakeitimus, kuriuos padarėte šiuo metu redaguojamame įraše.",
  "confirmations.discard_draft.edit.title": "Atmesti pakeitimus savo įraše?",
  "confirmations.discard_draft.post.cancel": "Tęsti juodraščio redagavimą",
  "confirmations.discard_draft.post.message": "Tęsdami ištrinsite šiuo metu kuriamą įrašą.",
  "confirmations.discard_draft.post.title": "Atmesti savo įrašo juodraštį?",
  "confirmations.discard_edit_media.confirm": "Atmesti",
  "confirmations.discard_edit_media.message": "Turi neišsaugotų medijos aprašymo ar peržiūros pakeitimų. Vis tiek juos atmesti?",
  "confirmations.follow_to_list.confirm": "Sekti ir pridėti prie sąrašo",
  "confirmations.follow_to_list.message": "Kad pridėtumėte juos į sąrašą, turite sekti {name}.",
  "confirmations.follow_to_list.title": "Sekti naudotoją?",
  "confirmations.logout.confirm": "Atsijungti",
  "confirmations.logout.message": "Ar tikrai nori atsijungti?",
  "confirmations.logout.title": "Atsijungti?",
  "confirmations.missing_alt_text.confirm": "Pridėti alternatyvųjį tekstą",
  "confirmations.missing_alt_text.message": "Jūsų įrašas turi mediją be alternatyvaus teksto. Pridėjus aprašymus, jūsų turinys taps pasiekiamas daugeliui asmenų.",
  "confirmations.missing_alt_text.secondary": "Siųsti vis tiek",
  "confirmations.missing_alt_text.title": "Pridėti alternatyvųjį tekstą?",
  "confirmations.mute.confirm": "Nutildyti",
  "confirmations.private_quote_notify.cancel": "Grįžti prie redagavimo",
  "confirmations.private_quote_notify.confirm": "Paskelbti įrašą",
  "confirmations.private_quote_notify.do_not_show_again": "Neberodyti šio pranešimo dar kartą",
  "confirmations.private_quote_notify.message": "Asmuo, kurį komentuojate, ir kiti paminėti asmenys bus informuoti ir galės peržiūrėti jūsų įrašą, net jei jie neseka jūsų.",
  "confirmations.private_quote_notify.title": "Bendrinti su sekėjais ir paminėtais (su @) naudotojais?",
  "confirmations.quiet_post_quote_info.dismiss": "Daugiau man nepriminti",
  "confirmations.quiet_post_quote_info.got_it": "Supratau",
  "confirmations.quiet_post_quote_info.message": "Kai norite komentuoti užtildytą viešą įrašą, jūsų įrašas bus paslėptas „Populiaru“ sąrašuose.",
  "confirmations.quiet_post_quote_info.title": "Kai paminite tylius viešus įrašus",
  "confirmations.redraft.confirm": "Ištrinti ir iš naujo parengti",
  "confirmations.redraft.message": "Ar tikrai nori ištrinti šį įrašą ir parengti jį iš naujo? Bus prarasti mėgstami ir pasidalinimai, o atsakymai į originalų įrašą bus panaikinti.",
  "confirmations.redraft.title": "Ištrinti ir iš naujo parengti įrašą?",
  "confirmations.remove_from_followers.confirm": "Šalinti sekėją",
  "confirmations.remove_from_followers.message": "{name} nustos jus sekti. Ar tikrai norite tęsti?",
  "confirmations.remove_from_followers.title": "Šalinti sekėją?",
  "confirmations.revoke_quote.confirm": "Pašalinti įrašą",
  "confirmations.revoke_quote.message": "Šio veiksmo negalima anuliuoti.",
  "confirmations.revoke_quote.title": "Pašalinti įrašą?",
  "confirmations.unblock.confirm": "Atblokuoti",
  "confirmations.unblock.title": "Atblokuoti {name}?",
  "confirmations.unfollow.confirm": "Nebesekti",
  "confirmations.unfollow.title": "Nebesekti {name}?",
  "confirmations.withdraw_request.confirm": "Atšaukti prašymą",
  "confirmations.withdraw_request.title": "Atšaukti prašymą sekti {name}?",
  "content_warning.hide": "Slėpti įrašą",
  "content_warning.show": "Rodyti vis tiek",
  "content_warning.show_more": "Rodyti daugiau",
  "conversation.delete": "Ištrinti pokalbį",
  "conversation.mark_as_read": "Žymėti kaip skaitytą",
  "conversation.open": "Peržiūrėti pokalbį",
  "conversation.with": "Su {names}",
  "copy_icon_button.copied": "Nukopijuota į iškarpinę",
  "copypaste.copied": "Nukopijuota",
  "copypaste.copy_to_clipboard": "Kopijuoti į iškarpinę",
  "directory.federated": "Iš žinomų fediversų",
  "directory.local": "Tik iš {domain}",
  "directory.new_arrivals": "Nauji atvykėliai",
  "directory.recently_active": "Neseniai aktyvus",
  "disabled_account_banner.account_settings": "Paskyros nustatymai",
  "disabled_account_banner.text": "Tavo paskyra {disabledAccount} šiuo metu išjungta.",
  "dismissable_banner.community_timeline": "Tai – naujausi vieši įrašai iš žmonių, kurių paskyros talpinamos {domain}.",
  "dismissable_banner.dismiss": "Atmesti",
  "dismissable_banner.public_timeline": "Tai yra naujausi vieši įrašai iš fediverse, kuriuos seka {domain} vartotojai.",
  "domain_block_modal.block": "Blokuoti serverį",
  "domain_block_modal.block_account_instead": "Blokuoti @{name} vietoj to",
  "domain_block_modal.they_can_interact_with_old_posts": "Žmonės iš šio serverio gali bendrauti su tavo senomis įrašomis.",
  "domain_block_modal.they_cant_follow": "Niekas iš šio serverio negali tavęs sekti.",
  "domain_block_modal.they_wont_know": "Jie nežinos, kad buvo užblokuoti.",
  "domain_block_modal.title": "Blokuoti serverį?",
  "domain_block_modal.you_will_lose_num_followers": "Prarasi {followersCount, plural, one {{followersCountDisplay} sekėją} few {{followersCountDisplay} sekėjus} many {{followersCountDisplay} sekėjo} other {{followersCountDisplay} sekėjų}} ir {followingCount, plural, one {{followingCountDisplay} žmogų, kurį seki} few {{followingCountDisplay} žmones, kuriuos seki} many {{followingCountDisplay} žmonės, kuriuos seki} other {{followingCountDisplay} žmonių, kurių seki}}.",
  "domain_block_modal.you_will_lose_relationships": "Prarasi visus sekėjus ir žmones, kuriuos seki iš šio serverio.",
  "domain_block_modal.you_wont_see_posts": "Nematysi naudotojų įrašų ar pranešimų šiame serveryje.",
  "domain_pill.activitypub_lets_connect": "Tai leidžia tau prisijungti ir bendrauti su žmonėmis ne tik „Mastodon“ platformoje, bet ir įvairiose socialinėse programėlėse.",
  "domain_pill.activitypub_like_language": "„ActivityPub“ – tai tarsi kalba, kuria „Mastodon“ kalba su kitais socialiniais tinklais.",
  "domain_pill.server": "Serveris",
  "domain_pill.their_handle": "Jų socialinis medijos vardas:",
  "domain_pill.their_server": "Jų skaitmeniniai namai, kuriuose saugomi visi jų įrašai.",
  "domain_pill.their_username": "Jų unikalus identifikatorius jų serveryje. Skirtinguose serveriuose galima rasti naudotojų su tuo pačiu naudotojo vardu.",
  "domain_pill.username": "Naudotojo vardas",
  "domain_pill.whats_in_a_handle": "Kas yra socialiniame medijos varde?",
  "domain_pill.who_they_are": "Kadangi socialines medijos vardai pasako, kas ir kur jie yra, galima bendrauti su žmonėmis visame socialiniame žiniatinklyje, kurį sudaro <button>„ActivityPub“ veikiančios platformos</button>.",
  "domain_pill.who_you_are": "Kadangi tavo socialinis medijos vardas pasako, kas ir kur esi, žmonės gali bendrauti su tavimi visame socialiniame žiniatinklyje, kurį sudaro <button>„ActivityPub“ veikiančios platformos</button>.",
  "domain_pill.your_handle": "Tavo socialinis medijos vardas:",
  "domain_pill.your_server": "Tavo skaitmeniniai namai, kuriuose saugomi visi tavo įrašai. Nepatinka šis? Bet kada perkelk serverius ir atsivesk ir savo sekėjus.",
  "domain_pill.your_username": "Tavo unikalus identifikatorius šiame serveryje. Skirtinguose serveriuose galima rasti naudotojų su tuo pačiu naudotojo vardu.",
  "dropdown.empty": "Pasirinkite variantą",
  "embed.instructions": "Įterpk šį įrašą į savo svetainę nukopijuojant toliau pateiktą kodą.",
  "embed.preview": "Štai kaip tai atrodys:",
  "emoji_button.activity": "Veikla",
  "emoji_button.clear": "Išvalyti",
  "emoji_button.custom": "Pasirinktinis",
  "emoji_button.flags": "Vėliavos",
  "emoji_button.food": "Maistas ir gėrimai",
  "emoji_button.label": "Įterpti jaustuką",
  "emoji_button.nature": "Gamta",
  "emoji_button.not_found": "Nerasta jokių tinkamų jaustukų.",
  "emoji_button.objects": "Objektai",
  "emoji_button.people": "Žmonės",
  "emoji_button.recent": "Dažniausiai naudojami",
  "emoji_button.search": "Ieškoti...",
  "emoji_button.search_results": "Paieškos rezultatai",
  "emoji_button.symbols": "Simboliai",
  "emoji_button.travel": "Kelionės ir vietos",
  "empty_column.account_hides_collections": "Šis (-i) naudotojas (-a) pasirinko nepadaryti šią informaciją prieinamą.",
  "empty_column.account_suspended": "Paskyra pristabdyta.",
  "empty_column.account_timeline": "Nėra čia įrašų.",
  "empty_column.account_unavailable": "Profilis neprieinamas.",
  "empty_column.blocks": "Dar neužblokavai nė vieno naudotojo.",
  "empty_column.bookmarked_statuses": "Dar neturi nė vienos įrašo su žyma. Kai vieną žymų pridėsi prie įrašo, jis bus rodomas čia.",
  "empty_column.community": "Vietinė laiko skalė yra tuščia. Parašyk ką nors viešai, kad pradėtum sąveikauti.",
  "empty_column.direct": "Dar neturi jokių asmeninių susirašinėjimų (su žyma @). Kai išsiųsi arba gausi vieną iš jų, jis bus rodomas čia.",
  "empty_column.disabled_feed": "Šis srautas buvo išjungtas jūsų serverio administratorių.",
  "empty_column.domain_blocks": "Kol kas nėra užblokuotų serverių.",
  "empty_column.explore_statuses": "Šiuo metu niekas nėra tendencinga. Patikrinkite vėliau!",
  "empty_column.favourited_statuses": "Dar neturi mėgstamų įrašų. Kai vieną iš jų pamėgsi, jis bus rodomas čia.",
  "empty_column.favourites": "Šio įrašo dar niekas nepamėgo. Kai kas nors tai padarys, jie bus rodomi čia.",
  "empty_column.follow_requests": "Dar neturi jokių sekimo prašymų. Kai gausi tokį prašymą, jis bus rodomas čia.",
  "empty_column.followed_tags": "Dar neseki jokių grotažymių. Kai tai padarysi, jos bus rodomos čia.",
  "empty_column.hashtag": "Šioje gratažymėje kol kas nieko nėra.",
  "empty_column.home": "Tavo pagrindinio laiko skalė tuščia. Sek daugiau žmonių, kad ją užpildytum.",
  "empty_column.list": "Šiame sąraše dar nieko nėra. Kai šio sąrašo nariai paskelbs naujus įrašus, jie bus rodomi čia.",
  "empty_column.mutes": "Dar nesi nutildęs (-usi) nė vieno naudotojo.",
  "empty_column.notification_requests": "Viskas švaru! Čia nieko nėra. Kai gausi naujų pranešimų, jie bus rodomi čia pagal tavo nustatymus.",
  "empty_column.notifications": "Dar neturi jokių pranešimų. Kai kiti žmonės su tavimi sąveikaus, matysi tai čia.",
  "empty_column.public": "Čia nieko nėra. Parašyk ką nors viešai arba rankiniu būdu sek naudotojus iš kitų serverių, kad jį užpildytum.",
  "error.no_hashtag_feed_access": "Registruokitės arba prisijunkite, kad galėtumėte peržiūrėti ir sekti šį žymę.",
  "error.unexpected_crash.explanation": "Dėl mūsų kodo riktos arba naršyklės suderinamumo problemos šis puslapis negalėjo būti rodomas teisingai.",
  "error.unexpected_crash.explanation_addons": "Šį puslapį nepavyko parodyti teisingai. Šią klaidą greičiausiai sukėlė naršyklės priedas arba automatinio vertimo įrankiai.",
  "error.unexpected_crash.next_steps": "Pabandyk atnaujinti puslapį. Jei tai nepadeda, galbūt vis dar galėsi naudotis Mastodon per kitą naršyklę arba savąją programėlę.",
  "error.unexpected_crash.next_steps_addons": "Pabandyk juos išjungti ir atnaujinti puslapį. Jei tai nepadeda, galbūt vis dar galėsi naudotis Mastodon per kitą naršyklę arba savąją programėlę.",
  "errors.unexpected_crash.copy_stacktrace": "Kopijuoti dėklo eigą į iškarpinę",
  "errors.unexpected_crash.report_issue": "Pranešti apie problemą",
  "explore.suggested_follows": "Žmonės",
  "explore.title": "Populiaru",
  "explore.trending_links": "Naujienos",
  "explore.trending_statuses": "Įrašai",
  "explore.trending_tags": "Grotažymės",
  "featured_carousel.current": "<sr>Įrašas</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, one {Iškeltas įrašas} few {Iškelti įrašai} many {Iškeltų įrašų} other {Iškelti įrašai}}",
  "featured_carousel.slide": "Įrašas {current, number} iš {max, number}",
  "filter_modal.added.context_mismatch_explanation": "Ši filtro kategorija netaikoma kontekstui, kuriame peržiūrėjai šį įrašą. Jei nori, kad įrašas būtų filtruojamas ir šiame kontekste, turėsi redaguoti filtrą.",
  "filter_modal.added.context_mismatch_title": "Konteksto neatitikimas.",
  "filter_modal.added.expired_explanation": "Ši filtro kategorija nustojo galioti. Kad ji būtų taikoma, turėsi pakeisti galiojimo datą.",
  "filter_modal.added.expired_title": "Baigėsi filtro galiojimas.",
  "filter_modal.added.review_and_configure": "Norint peržiūrėti ir toliau konfigūruoti šią filtro kategoriją, eik į {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Filtro nustatymai",
  "filter_modal.added.settings_link": "nustatymų puslapį",
  "filter_modal.added.short_explanation": "Šis įrašas buvo pridėtas į šią filtro kategoriją: {title}.",
  "filter_modal.added.title": "Pridėtas filtras.",
  "filter_modal.select_filter.context_mismatch": "netaikoma šiame kontekste.",
  "filter_modal.select_filter.expired": "nebegalioja.",
  "filter_modal.select_filter.prompt_new": "Nauja kategorija: {name}",
  "filter_modal.select_filter.search": "Ieškoti arba sukurti",
  "filter_modal.select_filter.subtitle": "Naudok esamą kategoriją arba sukurk naują.",
  "filter_modal.select_filter.title": "Filtruoti šį įrašą",
  "filter_modal.title.status": "Filtruoti įrašą",
  "filter_warning.matches_filter": "Atitinka filtrą „<span>{title}</span>“",
  "filtered_notifications_banner.pending_requests": "Iš {count, plural, =0 {nė vieno} one {žmogaus} few {# žmonių} many {# žmonių} other {# žmonių}}, kuriuos galbūt pažįsti",
  "filtered_notifications_banner.title": "Filtruojami pranešimai",
  "firehose.all": "Visi",
  "firehose.local": "Šis serveris",
  "firehose.remote": "Kiti serveriai",
  "follow_request.authorize": "Leisti",
  "follow_request.reject": "Atmesti",
  "follow_requests.unlocked_explanation": "Nors tavo paskyra neužrakinta, {domain} personalas mano, kad galbūt norėsi rankiniu būdu patikrinti šių paskyrų sekimo prašymus.",
  "follow_suggestions.curated_suggestion": "Personalo pasirinkimai",
  "follow_suggestions.dismiss": "Daugiau nerodyti",
  "follow_suggestions.featured_longer": "Rankomis atrinkta {domain} komanda",
  "follow_suggestions.friends_of_friends_longer": "Populiarus tarp žmonių, kurių seki",
  "follow_suggestions.hints.featured": "Šį profilį atrinko {domain} komanda.",
  "follow_suggestions.hints.friends_of_friends": "Šis profilis yra populiarus tarp žmonių, kuriuos seki.",
  "follow_suggestions.hints.most_followed": "Šis profilis yra vienas iš labiausiai sekamų domene {domain}.",
  "follow_suggestions.hints.most_interactions": "Pastaruoju metu šis profilis sulaukia daug dėmesio domane {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Šis profilis panašus į profilius, kuriuos neseniai sekei.",
  "follow_suggestions.personalized_suggestion": "Suasmenintas pasiūlymas",
  "follow_suggestions.popular_suggestion": "Populiarus pasiūlymas",
  "follow_suggestions.popular_suggestion_longer": "Populiarus domene {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Panašūs į profilius, kuriuos neseniai seki",
  "follow_suggestions.view_all": "Peržiūrėti viską",
  "follow_suggestions.who_to_follow": "Ką sekti",
  "followed_tags": "Grotažymės",
  "footer.about": "Apie",
  "footer.about_this_server": "Apie",
  "footer.directory": "Profilių katalogas",
  "footer.get_app": "Gauti programėlę",
  "footer.keyboard_shortcuts": "Spartieji klavišai",
  "footer.privacy_policy": "Privatumo politika",
  "footer.source_code": "Peržiūrėti šaltinio kodą",
  "footer.status": "Statusas",
  "footer.terms_of_service": "Paslaugų sąlygos",
  "generic.saved": "Išsaugota",
  "getting_started.heading": "Kaip pradėti",
  "hashtag.admin_moderation": "Atverti moderavimo langą #{name}",
  "hashtag.browse": "Naršyti įrašus su #{hashtag}",
  "hashtag.browse_from_account": "Naršyti @{name} įrašus su grotažyme #{hashtag}",
  "hashtag.column_header.tag_mode.all": "ir {additional}",
  "hashtag.column_header.tag_mode.any": "ar {additional}",
  "hashtag.column_header.tag_mode.none": "be {additional}",
  "hashtag.column_settings.select.no_options_message": "Pasiūlymų nerasta.",
  "hashtag.column_settings.select.placeholder": "Įvesk grotažymes…",
  "hashtag.column_settings.tag_mode.all": "Visi šie",
  "hashtag.column_settings.tag_mode.any": "Bet kuris šių",
  "hashtag.column_settings.tag_mode.none": "Nei vienas šių",
  "hashtag.column_settings.tag_toggle": "Įtraukti papildomas žymas į šį stulpelį",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} dalyvis} few {{counter} dalyviai} many {{counter} dalyvių} other {{counter} dalyviai}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} įrašas} few {{counter} įrašai} many {{counter} įrašo} other {{counter} įrašų}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} įrašas} few {{counter} įrašai} many {{counter} įrašo} other {{counter} įrašų}} šiandien",
  "hashtag.feature": "Rodyti profilyje",
  "hashtag.follow": "Sekti grotažymę",
  "hashtag.mute": "Nutildyti žymą #{hashtag}",
  "hashtag.unfeature": "Neberodyti profilyje",
  "hashtag.unfollow": "Nebesekti grotažymės",
  "hashtags.and_other": "…ir {count, plural, one {# daugiau} few {# daugiau} many {# daugiau}other {# daugiau}}",
  "hints.profiles.followers_may_be_missing": "Sekėjai šiai profiliui gali būti nepateikti.",
  "hints.profiles.follows_may_be_missing": "Sekimai šiai profiliui gali būti nepateikti.",
  "hints.profiles.posts_may_be_missing": "Kai kurie įrašai iš šio profilio gali būti nepateikti.",
  "hints.profiles.see_more_followers": "Žiūrėti daugiau sekėjų serveryje {domain}",
  "hints.profiles.see_more_follows": "Žiūrėti daugiau sekimų serveryje {domain}",
  "hints.profiles.see_more_posts": "Žiūrėti daugiau įrašų serveryje {domain}",
  "home.column_settings.show_quotes": "Rodyti komentarus",
  "home.column_settings.show_reblogs": "Rodyti pakėlimus",
  "home.column_settings.show_replies": "Rodyti atsakymus",
  "home.hide_announcements": "Slėpti skelbimus",
  "home.pending_critical_update.body": "Kuo greičiau atnaujink savo Mastodon serverį.",
  "home.pending_critical_update.link": "Žiūrėti naujinimus",
  "home.pending_critical_update.title": "Galimas kritinis saugumo naujinimas.",
  "home.show_announcements": "Rodyti skelbimus",
  "ignore_notifications_modal.disclaimer": "„Mastodon“ negali informuoti naudotojų, kad ignoravai jų pranešimus. Ignoravus pranešimus, pačių pranešimų siuntimas nebus sustabdytas.",
  "ignore_notifications_modal.filter_instead": "Filtruoti vietoj to",
  "ignore_notifications_modal.filter_to_act_users": "Vis dar galėsi priimti, atmesti arba pranešti naudotojus.",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Filtravimas padeda išvengti galimos painiavos.",
  "ignore_notifications_modal.filter_to_review_separately": "Filtruotus pranešimus gali peržiūrėti atskirai.",
  "ignore_notifications_modal.ignore": "Ignoruoti pranešimus",
  "ignore_notifications_modal.limited_accounts_title": "Ignoruoti pranešimus iš prižiūrėmų paskyrų?",
  "ignore_notifications_modal.new_accounts_title": "Ignoruoti pranešimus iš naujų paskyrų?",
  "ignore_notifications_modal.not_followers_title": "Ignoruoti pranešimus iš žmonių, kurie tave neseka?",
  "ignore_notifications_modal.not_following_title": "Ignoruoti pranešimus iš žmonių, kuriuos neseki?",
  "ignore_notifications_modal.private_mentions_title": "Ignoruoti pranešimus iš neprašytų privačių susirašinėjimų (su @)?",
  "info_button.label": "Žinynas",
  "info_button.what_is_alt_text": "<h1>Kas yra alternatyvusis tekstas?</h1> <p>Alternatyvusis tekstas pateikia vaizdų aprašymus asmenims su regos sutrikimais, turintiems mažo pralaidumo ryšį arba ieškantiems papildomo konteksto.</p> <p>Galite pagerinti prieinamumą ir suprantamumą visiems, jei parašysite aiškų, glaustą ir objektyvų alternatyvųjį tekstą.</p> <ul> <li>Užfiksuokite svarbiausius elementus.</li> <li>Apibendrinkite tekstą vaizduose.</li> <li>Naudokite įprasta sakinio struktūrą.</li> <li>Venkite nereikalingos informacijos.</li> <li>Sutelkite dėmesį į tendencijas ir pagrindines išvadas sudėtinguose vaizdiniuose (tokiuose kaip diagramos ar žemėlapiai).</li> </ul>",
  "interaction_modal.action": "Norėdami bendrauti su {name} įrašu, turite prisijungti prie savo paskyros bet kuriame Mastodon serveryje, kurį naudojate.",
  "interaction_modal.go": "Eiti",
  "interaction_modal.no_account_yet": "Dar neturite paskyros?",
  "interaction_modal.on_another_server": "Kitame serveryje",
  "interaction_modal.on_this_server": "Šiame serveryje",
  "interaction_modal.title": "Jei norite tęsti, prisijunkite",
  "interaction_modal.username_prompt": "Pvz., {example}",
  "intervals.full.days": "{number, plural, one {# diena} few {# dienos} many {# dienos} other {# dienų}}",
  "intervals.full.hours": "{number, plural, one {# valanda} few {# valandos} many {# valandos} other {# valandų}}",
  "intervals.full.minutes": "{number, plural, one {# minutė} few {# minutes} many {# minutės} other {# minučių}}",
  "keyboard_shortcuts.back": "Naršyti atgal",
  "keyboard_shortcuts.blocked": "Atidaryti užblokuotų naudotojų sąrašą",
  "keyboard_shortcuts.boost": "Dalintis įrašu",
  "keyboard_shortcuts.column": "Fokusuoti stulpelį",
  "keyboard_shortcuts.compose": "Fokusuoti rengykles teksto sritį",
  "keyboard_shortcuts.description": "Aprašymas",
  "keyboard_shortcuts.down": "Perkelti žemyn sąraše",
  "keyboard_shortcuts.enter": "Atidaryti įrašą",
  "keyboard_shortcuts.favourite": "Pamėgti įrašą",
  "keyboard_shortcuts.favourites": "Atidaryti mėgstamųjų sąrašą",
  "keyboard_shortcuts.federated": "Atidaryti federacinę laiko skalę",
  "keyboard_shortcuts.heading": "Spartieji klavišai",
  "keyboard_shortcuts.home": "Atidaryti pagrindinį laiko skalę",
  "keyboard_shortcuts.hotkey": "Spartusis klavišas",
  "keyboard_shortcuts.legend": "Rodyti šią legendą",
  "keyboard_shortcuts.load_more": "Fokusuoti „Įkelti daugiau“ mygtuką",
  "keyboard_shortcuts.local": "Atidaryti vietinę laiko skalę",
  "keyboard_shortcuts.mention": "Paminėti autorių (-ę)",
  "keyboard_shortcuts.muted": "Atidaryti nutildytų naudotojų sąrašą",
  "keyboard_shortcuts.my_profile": "Atidaryti savo profilį",
  "keyboard_shortcuts.notifications": "Atidaryti pranešimų stulpelį",
  "keyboard_shortcuts.open_media": "Atidaryti mediją",
  "keyboard_shortcuts.pinned": "Atverti prisegtų įrašų sąrašą",
  "keyboard_shortcuts.profile": "Atidaryti autoriaus (-ės) profilį",
  "keyboard_shortcuts.quote": "Komentuoti įrašą",
  "keyboard_shortcuts.reply": "Atsakyti į įrašą",
  "keyboard_shortcuts.requests": "Atidaryti sekimo prašymų sąrašą",
  "keyboard_shortcuts.search": "Fokusuoti paieškos juostą",
  "keyboard_shortcuts.spoilers": "Rodyti / slėpti TĮ lauką",
  "keyboard_shortcuts.start": "Atidarykite stulpelį Kaip pradėti",
  "keyboard_shortcuts.toggle_hidden": "Rodyti / slėpti tekstą po TĮ",
  "keyboard_shortcuts.toggle_sensitivity": "Rodyti / slėpti mediją",
  "keyboard_shortcuts.toot": "Pradėti naują įrašą",
  "keyboard_shortcuts.top": "Perkelti į sąrašo viršų",
  "keyboard_shortcuts.translate": "išversti įrašą",
  "keyboard_shortcuts.unfocus": "Nebefokusuoti rengykles teksto sritį / paiešką",
  "keyboard_shortcuts.up": "Perkelti į viršų sąraše",
  "learn_more_link.got_it": "Supratau",
  "learn_more_link.learn_more": "Sužinoti daugiau",
  "lightbox.close": "Uždaryti",
  "lightbox.next": "Kitas",
  "lightbox.previous": "Ankstesnis",
  "lightbox.zoom_in": "Padidink iki tikrojo dydžio",
  "lightbox.zoom_out": "Padidink, kad tilptų",
  "limited_account_hint.action": "Vis tiek rodyti profilį",
  "limited_account_hint.title": "Šį profilį paslėpė {domain} prižiūrėtojai.",
  "link_preview.author": "Sukūrė {name}",
  "link_preview.more_from_author": "Daugiau iš {name}",
  "link_preview.shares": "{count, plural, one {{counter} įrašas} few {{counter} įrašai} many {{counter} įrašo} other {{counter} įrašų}}",
  "lists.add_member": "Pridėti",
  "lists.add_to_list": "Pridėti į sąrašą",
  "lists.add_to_lists": "Pridėti {name} į sąrašą",
  "lists.create": "Kurti",
  "lists.create_a_list_to_organize": "Sukurkite naują sąrašą, kad sutvarkytumėte pagrindinį srautą",
  "lists.create_list": "Kurti sąrašą",
  "lists.delete": "Ištrinti sąrašą",
  "lists.done": "Atlikta",
  "lists.edit": "Redaguoti sąrašą",
  "lists.exclusive": "Slėpti narius pagrindiniame",
  "lists.exclusive_hint": "Jei kas nors yra šiame sąraše, paslėpkite juos pagrindinio srauto laiko skalėje, kad nematytumėte jų įrašus dukart.",
  "lists.find_users_to_add": "Raskite naudotojų, kurių pridėti",
  "lists.list_members_count": "{count, plural, one {# narys} few {# nariai} many {# nario} other {# narių}}",
  "lists.list_name": "Sąrašo pavadinimas",
  "lists.new_list_name": "Naujas sąrašo pavadinimas",
  "lists.no_lists_yet": "Kol kas nėra sąrašų.",
  "lists.no_members_yet": "Kol kas nėra narių.",
  "lists.no_results_found": "Rezultatų nerasta.",
  "lists.remove_member": "Šalinti",
  "lists.replies_policy.followed": "Bet kuriam sekamam naudotojui",
  "lists.replies_policy.list": "Sąrašo nariams",
  "lists.replies_policy.none": "Nei vienam",
  "lists.save": "Išsaugoti",
  "lists.search": "Ieškoti",
  "lists.show_replies_to": "Įtraukti atsakymus iš sąrašo narių į",
  "load_pending": "{count, plural, one {# naujas elementas} few {# nauji elementai} many {# naujo elemento} other {# naujų elementų}}",
  "loading_indicator.label": "Kraunama…",
  "media_gallery.hide": "Slėpti",
  "moved_to_account_banner.text": "Tavo paskyra {disabledAccount} šiuo metu išjungta, nes persikėlei į {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Slėpti nuo pranešimų",
  "mute_modal.hide_options": "Slėpti parinktis",
  "mute_modal.indefinite": "Kol atšauksiu jų nutildymą",
  "mute_modal.show_options": "Rodyti parinktis",
  "mute_modal.they_can_mention_and_follow": "Jie gali tave paminėti tave su @ ir sekti tave, bet tu jų nematysi.",
  "mute_modal.they_wont_know": "Jie nežinos, kad buvo nutildyti.",
  "mute_modal.title": "Nutildyti naudotoją?",
  "mute_modal.you_wont_see_mentions": "Nematysi įrašų, kuriuose jie paminimi.",
  "mute_modal.you_wont_see_posts": "Jie vis tiek gali matyti tavo įrašus, bet tu nematysi jų.",
  "navigation_bar.about": "Apie",
  "navigation_bar.account_settings": "Slaptažodis ir saugumas",
  "navigation_bar.administration": "Administravimas",
  "navigation_bar.advanced_interface": "Atidaryti išplėstinę žiniatinklio sąsają",
  "navigation_bar.automated_deletion": "Automatinis įrašų ištrynimas",
  "navigation_bar.blocks": "Užblokuoti naudotojai",
  "navigation_bar.bookmarks": "Žymės",
  "navigation_bar.direct": "Paminėjimai",
  "navigation_bar.domain_blocks": "Užblokuoti domenai",
  "navigation_bar.favourites": "Mėgstami",
  "navigation_bar.filters": "Nutildyti žodžiai",
  "navigation_bar.follow_requests": "Sekimo prašymai",
  "navigation_bar.followed_tags": "Grotažymės",
  "navigation_bar.follows_and_followers": "Sekimai ir sekėjai",
  "navigation_bar.import_export": "Importas ir eksportas",
  "navigation_bar.lists": "Sąrašai",
  "navigation_bar.live_feed_local": "Tiesioginis srautas (vietinis)",
  "navigation_bar.live_feed_public": "Tiesioginis srautas (viešas)",
  "navigation_bar.logout": "Atsijungti",
  "navigation_bar.moderation": "Prižiūrėjimas",
  "navigation_bar.more": "Daugiau",
  "navigation_bar.mutes": "Nutildyti naudotojai",
  "navigation_bar.opened_in_classic_interface": "Įrašai, paskyros ir kiti konkretūs puslapiai pagal numatytuosius nustatymus atidaromi klasikinėje žiniatinklio sąsajoje.",
  "navigation_bar.preferences": "Nuostatos",
  "navigation_bar.privacy_and_reach": "Privatumas ir pasiekiamumas",
  "navigation_bar.search": "Ieškoti",
  "navigation_bar.search_trends": "Paieška / Populiaru",
  "navigation_panel.collapse_followed_tags": "Sutraukti sekamų žymių meniu",
  "navigation_panel.collapse_lists": "Sutraukti sąrašo meniu",
  "navigation_panel.expand_followed_tags": "Išskleisti sekamų grotažymių meniu",
  "navigation_panel.expand_lists": "Išskleisti sąrašo meniu",
  "not_signed_in_indicator.not_signed_in": "Norint pasiekti šį išteklį, reikia prisijungti.",
  "notification.admin.report": "{name} pranešė {target}",
  "notification.admin.report_account": "{name} pranešė {count, plural, one {# įrašą} few {# įrašus} many {# įrašo} other {# įrašų}} iš {target} kategorijai {category}",
  "notification.admin.report_account_other": "{name} pranešė {count, plural, one {# įrašą} few {# įrašus} many {# įrašo} other {# įrašų}} iš {target}",
  "notification.admin.report_statuses": "{name} pranešė {target} kategorijai {category}",
  "notification.admin.report_statuses_other": "{name} pranešė {target}",
  "notification.admin.sign_up": "{name} užsiregistravo",
  "notification.admin.sign_up.name_and_others": "{name} ir {count, plural, one {# kitas} few {# kiti} many {# kito} other {# kitų}} užsiregistravo",
  "notification.annual_report.message": "Jūsų laukia {year} #Wrapstodon! Atskleiskite savo metų svarbiausius įvykius ir įsimintinas akimirkas platformoje „Mastodon“.",
  "notification.annual_report.view": "Peržiūrėti #Wrapstodon",
  "notification.favourite": "{name} pamėgo tavo įrašą",
  "notification.favourite.name_and_others_with_link": "{name} ir <a>{count, plural,one {dar kažkas} few {# kiti} other {# kitų}}</a> pamėgo tavo įrašą",
  "notification.favourite_pm": "{name} pamėgo jūsų privatų paminėjimą",
  "notification.favourite_pm.name_and_others_with_link": "{name} ir <a>{count, plural,one {dar kažkas} few {# kiti} other {# kitų}}</a> pamėgo tavo privatų paminėjimą",
  "notification.follow": "{name} seka tave",
  "notification.follow.name_and_others": "{name} ir <a>{count, plural, one {# kitas} few {# kiti} many {# kito} other {# kitų}}</a> seka tave",
  "notification.follow_request": "{name} paprašė tave sekti",
  "notification.follow_request.name_and_others": "{name} ir {count, plural,one {dar kažkas} few {# kiti} other {# kitų}} pradėjo tave sekti",
  "notification.label.mention": "Paminėjimas",
  "notification.label.private_mention": "Privatus paminėjimas",
  "notification.label.private_reply": "Privatus atsakymas",
  "notification.label.quote": "{name} pakomentavo jūsų įrašą",
  "notification.label.reply": "Atsakymas",
  "notification.mention": "Paminėjimas",
  "notification.mentioned_you": "{name} paminėjo jus",
  "notification.moderation-warning.learn_more": "Sužinoti daugiau",
  "notification.moderation_warning": "Gavai prižiūrėjimo įspėjimą",
  "notification.moderation_warning.action_delete_statuses": "Kai kurie tavo įrašai buvo pašalintos.",
  "notification.moderation_warning.action_disable": "Tavo paskyra buvo išjungta.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Kai kurie tavo įrašai buvo pažymėti kaip turintys jautrią informaciją.",
  "notification.moderation_warning.action_none": "Tavo paskyra gavo prižiūrėjimo įspėjimą.",
  "notification.moderation_warning.action_sensitive": "Nuo šiol tavo įrašai bus pažymėti kaip su jautria informacija.",
  "notification.moderation_warning.action_silence": "Tavo paskyra buvo apribota.",
  "notification.moderation_warning.action_suspend": "Tavo paskyra buvo sustabdyta.",
  "notification.own_poll": "Tavo apklausa baigėsi",
  "notification.poll": "Baigėsi apklausa, kurioje balsavai",
  "notification.quoted_update": "{name} redagavo jūsų pakomentuotą įrašą",
  "notification.reblog": "{name} dalinosi tavo įrašu",
  "notification.reblog.name_and_others_with_link": "{name} ir <a>{count, plural,one {dar kažkas} few {# kiti} other {# kitų}}</a> pasidalino tavo įrašu",
  "notification.relationships_severance_event": "Prarasti sąryšiai su {name}",
  "notification.relationships_severance_event.account_suspension": "Administratorius iš {from} sustabdė {target}, todėl jūs nebegalėsite gauti jų naujienų ar bendrauti su jais.",
  "notification.relationships_severance_event.domain_block": "Administratorius iš {from} užblokavo {target}, įskaitant {followersCount} iš tavo sekėjų ir {followingCount, plural,one {# žmogų, kurį} few {# žmones, kuriuos} other {# žmonių, kuriuos}} seki.",
  "notification.relationships_severance_event.learn_more": "Sužinoti daugiau",
  "notification.relationships_severance_event.user_domain_block": "Tu užblokavai {target}. Pašalinama {followersCount} savo sekėjų ir {followingCount, plural, one {# paskyrą} few {# paskyrai} many {# paskyros} other {# paskyrų}}, kurios seki.",
  "notification.status": "{name} ką tik paskelbė",
  "notification.update": "{name} redagavo įrašą",
  "notification_requests.accept": "Priimti",
  "notification_requests.accept_multiple": "{count, plural, one {Priimti # prašymą…} few {Priimti # prašymus…} many {Priimti # prašymo…} other {Priimti # prašymų…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Priimti prašymą} few {Priimti prašymus} many {Priimti prašymo} other {Priimti prašymų}}",
  "notification_requests.confirm_accept_multiple.message": "Ketini priimti {count, plural, one {# pranešimo prašymą} few {# pranešimų prašymus} many {# pranešimo prašymo} other {# pranešimų prašymų}}. Ar tikrai nori tęsti?",
  "notification_requests.confirm_accept_multiple.title": "Priimti pranešimų prašymus?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Atmesti prašymą} few {Atmesti prašymus} many {Atmesti prašymo} other {Atmesti prašymų}}",
  "notification_requests.confirm_dismiss_multiple.message": "Ketini atmesti {count, plural, one {# pranešimo prašymą} few {# pranešimų prašymus} many {# pranešimo prašymo} other {# pranešimų prašymų}}. Daugiau negalėsi lengvai pasiekti {count, plural, one {jo} few {jų} many {juos} other {jų}}. Ar tikrai nori tęsti?",
  "notification_requests.confirm_dismiss_multiple.title": "Atmesti pranešimų prašymus?",
  "notification_requests.dismiss": "Atmesti",
  "notification_requests.dismiss_multiple": "{count, plural, one {Atmesti prašymą…} few {Atmesti prašymus…} many {Atmesti prašymo…} other {Atmesti prašymų…}}",
  "notification_requests.edit_selection": "Redaguoti",
  "notification_requests.exit_selection": "Atlikta",
  "notification_requests.explainer_for_limited_account": "Pranešimai iš šios paskyros buvo filtruojami, nes prižiūrėtojas (-a) apribojo paskyrą.",
  "notification_requests.explainer_for_limited_remote_account": "Pranešimai iš šios paskyros buvo filtruojami, nes prižiūrėtojas (-a) apribojo paskyrą arba serverį.",
  "notification_requests.maximize": "Padidinti",
  "notification_requests.minimize_banner": "Mažinti filtruotų pranešimų reklamjuostę",
  "notification_requests.notifications_from": "Pranešimai iš {name}",
  "notification_requests.title": "Filtruojami pranešimai",
  "notification_requests.view": "Peržiūrėti pranešimus",
  "notifications.clear": "Išvalyti pranešimus",
  "notifications.clear_confirmation": "Ar tikrai nori visam laikui išvalyti visus pranešimus?",
  "notifications.clear_title": "Valyti pranešimus?",
  "notifications.column_settings.admin.report": "Naujos ataskaitos:",
  "notifications.column_settings.admin.sign_up": "Naujos registracijos:",
  "notifications.column_settings.alert": "Darbalaukio pranešimai",
  "notifications.column_settings.favourite": "Mėgstami:",
  "notifications.column_settings.filter_bar.advanced": "Rodyti visas kategorijas",
  "notifications.column_settings.filter_bar.category": "Spartaus filtro juosta",
  "notifications.column_settings.follow": "Nauji sekėjai:",
  "notifications.column_settings.follow_request": "Nauji sekimo prašymai:",
  "notifications.column_settings.group": "Grupė",
  "notifications.column_settings.mention": "Paminėjimai:",
  "notifications.column_settings.poll": "Balsavimo rezultatai:",
  "notifications.column_settings.push": "Tiesioginiai pranešimai",
  "notifications.column_settings.quote": "Komentarai:",
  "notifications.column_settings.reblog": "Pasidalinimai:",
  "notifications.column_settings.show": "Rodyti stulpelyje",
  "notifications.column_settings.sound": "Paleisti garsą",
  "notifications.column_settings.status": "Nauji įrašai:",
  "notifications.column_settings.unread_notifications.category": "Neperskaityti pranešimai",
  "notifications.column_settings.unread_notifications.highlight": "Paryškinti neperskaitytus pranešimus",
  "notifications.column_settings.update": "Redagavimai:",
  "notifications.filter.all": "Visi",
  "notifications.filter.boosts": "Pasidalinimai",
  "notifications.filter.favourites": "Mėgstami",
  "notifications.filter.follows": "Sekimai",
  "notifications.filter.mentions": "Paminėjimai",
  "notifications.filter.polls": "Balsavimo rezultatai",
  "notifications.filter.statuses": "Naujienos iš žmonių, kuriuos sekate",
  "notifications.grant_permission": "Suteikti leidimą.",
  "notifications.group": "{count} pranešimai",
  "notifications.mark_as_read": "Pažymėti kiekvieną pranešimą kaip perskaitytą",
  "notifications.permission_denied": "Darbalaukio pranešimai nepasiekiami dėl anksčiau atmestos naršyklės leidimų užklausos.",
  "notifications.permission_denied_alert": "Negalima įjungti darbalaukio pranešimų, nes prieš tai naršyklės leidimas buvo atmestas.",
  "notifications.permission_required": "Darbalaukio pranešimai nepasiekiami, nes nebuvo suteiktas reikiamas leidimas.",
  "notifications.policy.accept": "Priimti",
  "notifications.policy.accept_hint": "Rodyti pranešimuose",
  "notifications.policy.drop": "Ignoruoti",
  "notifications.policy.drop_hint": "Siųsti į tuštumą, kad daugiau niekada nebepasirodytų",
  "notifications.policy.filter": "Filtruoti",
  "notifications.policy.filter_hint": "Siųsti į filtruotų pranešimų gautiejus",
  "notifications.policy.filter_limited_accounts_hint": "Apribota serverio prižiūrėtojų",
  "notifications.policy.filter_limited_accounts_title": "Moderuojamos paskyros",
  "notifications.policy.filter_new_accounts.hint": "Sukurta per {days, plural, one {vieną dieną} few {# dienas} many {# dienos} other {# dienų}}",
  "notifications.policy.filter_new_accounts_title": "Naujos paskyros",
  "notifications.policy.filter_not_followers_hint": "Įskaitant žmones, kurie seka jus mažiau nei {days, plural, one {vieną dieną} few {# dienas} many {# dienų} other {# dienų}}",
  "notifications.policy.filter_not_followers_title": "Žmonės, kurie neseka tavęs",
  "notifications.policy.filter_not_following_hint": "Kol jų nepatvirtinsi rankiniu būdu",
  "notifications.policy.filter_not_following_title": "Žmonių, kuriuos neseki",
  "notifications.policy.filter_private_mentions_hint": "Filtruojama, išskyrus atsakymus į tavo paties paminėjimą arba jei seki siuntėją",
  "notifications.policy.filter_private_mentions_title": "Nepageidaujami asmens paminėjimai",
  "notifications.policy.title": "Tvarkyti pranešimus iš…",
  "notifications_permission_banner.enable": "Įjungti darbalaukio pranešimus",
  "notifications_permission_banner.how_to_control": "Jei nori gauti pranešimus, kai Mastodon nėra atidarytas, įjunk darbalaukio pranešimus. Įjungęs (-usi) darbalaukio pranešimus, gali tiksliai valdyti, kokių tipų sąveikos generuoja darbalaukio pranešimus, naudojant pirmiau esančiu mygtuku {icon}.",
  "notifications_permission_banner.title": "Niekada nieko nepraleisk",
  "onboarding.follows.back": "Atgal",
  "onboarding.follows.empty": "Deja, šiuo metu jokių rezultatų parodyti negalima. Gali pabandyti naudoti paiešką arba naršyti atradimo puslapį, kad surastum žmonių, kuriuos nori sekti, arba bandyti vėliau.",
  "onboarding.follows.search": "Ieškoti",
  "onboarding.follows.title": "Sekite asmenis, kad pradėtumėte",
  "onboarding.profile.discoverable": "Padaryti mano profilį atrandamą",
  "onboarding.profile.discoverable_hint": "Kai sutinki su Mastodon atrandamumu, tavo įrašai gali būti rodomi paieškos rezultatuose ir tendencijose, o profilis gali būti siūlomas panašių pomėgių turintiems žmonėms.",
  "onboarding.profile.display_name": "Rodomas vardas",
  "onboarding.profile.display_name_hint": "Tavo pilnas vardas arba linksmas vardas…",
  "onboarding.profile.note": "Biografija",
  "onboarding.profile.note_hint": "Gali @paminėti kitus žmones arba #saitažodžius…",
  "onboarding.profile.title": "Profilio sąranka",
  "onboarding.profile.upload_avatar": "Įkelti profilio nuotrauką",
  "onboarding.profile.upload_header": "Įkelti profilio antraštę",
  "password_confirmation.exceeds_maxlength": "Slaptažodžio patvirtinimas viršija maksimalų slaptažodžio ilgį.",
  "password_confirmation.mismatching": "Slaptažodžio patvirtinimas nesutampa.",
  "picture_in_picture.restore": "Padėti jį atgal",
  "poll.closed": "Uždaryta",
  "poll.refresh": "Atnaujinti",
  "poll.reveal": "Peržiūrėti rezultatus",
  "poll.total_people": "{count, plural, one {# žmogus} few {# žmonės} many {# žmogus} other {# žmonių}}",
  "poll.total_votes": "{count, plural, one {# balsas} few {# balsai} many {# balso} other {# balsų}}",
  "poll.vote": "Balsuoti",
  "poll.voted": "Tu balsavai už šį atsakymą",
  "poll.votes": "{votes, plural, one {# balsas} few {# balsai} many {# balso} other {# balsų}}",
  "poll_button.add_poll": "Pridėti apklausą",
  "poll_button.remove_poll": "Pašalinti apklausą",
  "privacy.change": "Keisti įrašo privatumą",
  "privacy.direct.long": "Visus, paminėtus įraše",
  "privacy.direct.short": "Privatus paminėjimas",
  "privacy.private.long": "Tik sekėjams",
  "privacy.private.short": "Sekėjai",
  "privacy.public.long": "Bet kas iš Mastodon ir ne Mastodon",
  "privacy.public.short": "Vieša",
  "privacy.quote.anyone": "{visibility}, komentarai galimi",
  "privacy.quote.disabled": "{visibility}, komentavimas išjungtas",
  "privacy.quote.limited": "{visibility}, komentavimas apribotas",
  "privacy.unlisted.additional": "Tai veikia lygiai taip pat, kaip ir vieša, tik įrašas nebus rodomas tiesioginiuose srautuose, grotažymėse, naršyme ar Mastodon paieškoje, net jei esi įtraukęs (-usi) visą paskyrą.",
  "privacy.unlisted.long": "Paslėptas nuo „Mastodon“ paieškos rezultatų, tendencijų ir viešų įrašų sienų",
  "privacy.unlisted.short": "Tyliai vieša",
  "privacy_policy.last_updated": "Paskutinį kartą atnaujinta {date}",
  "privacy_policy.title": "Privatumo politika",
  "quote_error.edit": "Komentuoti negalima, kai keičiamas įrašas.",
  "quote_error.poll": "Komentuoti apklausose negalima.",
  "quote_error.private_mentions": "Komentuoti privačius paminėjimus nėra leidžiama.",
  "quote_error.quote": "Leidžiama pateikti tik vieną komentarą vienu metu.",
  "quote_error.unauthorized": "Jums neleidžiama komentuoti šio įrašo.",
  "quote_error.upload": "Cituoti ir pridėti papildomas bylas negalima.",
  "recommended": "Rekomenduojama",
  "refresh": "Atnaujinti",
  "regeneration_indicator.please_stand_by": "Laukite.",
  "regeneration_indicator.preparing_your_home_feed": "Ruošimas jūsų pagrindinis srautas…",
  "relative_time.days": "{number} d.",
  "relative_time.full.days": "prieš {number, plural, one {# dieną} few {# dienas} many {# dienos} other {# dienų}}",
  "relative_time.full.hours": "prieš {number, plural, one {# valandą} few {# valandas} many {# valandos} other {# valandų}}",
  "relative_time.full.just_now": "ką tik",
  "relative_time.full.minutes": "prieš {number, plural, one {# minutę} few {# minutes} many {# minutės} other {# minučių}}",
  "relative_time.full.seconds": "prieš {number, plural, one {# sekundę} few {# sekundes} many {# sekundės} other {# sekundžių}}",
  "relative_time.hours": "{number} val.",
  "relative_time.just_now": "dabar",
  "relative_time.minutes": "{number} min.",
  "relative_time.seconds": "{number} sek.",
  "relative_time.today": "šiandien",
  "remove_quote_hint.button_label": "Supratau",
  "remove_quote_hint.message": "Tai galite padaryti iš {icon} parinkčių meniu.",
  "remove_quote_hint.title": "Norite pašalinti savo komentarą?",
  "reply_indicator.attachments": "{count, plural, one {# priedas} few {# priedai} many {# priedo} other {# priedų}}",
  "reply_indicator.cancel": "Atšaukti",
  "reply_indicator.poll": "Apklausa",
  "report.block": "Blokuoti",
  "report.block_explanation": "Jų įrašų nematysi. Jie negalės matyti tavo įrašų ar sekti tavęs. Jie galės pamatyti, kad yra užblokuoti.",
  "report.categories.legal": "Teisinės",
  "report.categories.other": "Kita",
  "report.categories.spam": "Šlamštas",
  "report.categories.violation": "Turinys pažeidžia vieną ar daugiau serverio taisyklių",
  "report.category.subtitle": "Pasirink geriausią atitikmenį.",
  "report.category.title": "Papasakok mums, kas vyksta su šiuo {type}",
  "report.category.title_account": "profiliu",
  "report.category.title_status": "įrašas",
  "report.close": "Atlikta",
  "report.comment.title": "Ar yra dar kas nors, ką, tavo manymu, turėtume žinoti?",
  "report.forward": "Persiųsti į {target}",
  "report.forward_hint": "Paskyra yra iš kito serverio. Siųsti anoniminę šios ataskaitos kopiją ir ten?",
  "report.mute": "Nutildyti",
  "report.mute_explanation": "Jų įrašų nematysi. Jie vis tiek gali tave sekti ir matyti įrašus, bet nežinos, kad jie nutildyti.",
  "report.next": "Tęsti",
  "report.placeholder": "Papildomi komentarai",
  "report.reasons.dislike": "Man tai nepatinka",
  "report.reasons.dislike_description": "Tai nėra tai, ką nori matyti",
  "report.reasons.legal": "Tai nelegalu",
  "report.reasons.legal_description": "Manai, kad tai pažeidžia tavo arba serverio šalies įstatymus",
  "report.reasons.other": "Tai kažkas kita",
  "report.reasons.other_description": "Problema netinka kitoms kategorijoms",
  "report.reasons.spam": "Tai – šlamštas",
  "report.reasons.spam_description": "Kenkėjiškos nuorodos, netikras įsitraukimas arba pasikartojantys atsakymai",
  "report.reasons.violation": "Tai pažeidžia serverio taisykles",
  "report.reasons.violation_description": "Žinai, kad tai pažeidžia konkrečias taisykles",
  "report.rules.subtitle": "Pasirink viską, kas tinka.",
  "report.rules.title": "Kokios taisyklės pažeidžiamos?",
  "report.statuses.subtitle": "Pasirink viską, kas tinka.",
  "report.statuses.title": "Ar yra kokių nors įrašų, patvirtinančių šį ataskaitą?",
  "report.submit": "Pateikti",
  "report.target": "Pranešama apie {target}",
  "report.thanks.take_action": "Štai parinktys, kaip kontroliuoti, ką matai Mastodon:",
  "report.thanks.take_action_actionable": "Kol peržiūrėsime, gali imtis veiksmų prieš {name}:",
  "report.thanks.title": "Nenori to matyti?",
  "report.thanks.title_actionable": "Ačiū, kad pranešei, mes tai išnagrinėsime.",
  "report.unfollow": "Nebesekti @{name}",
  "report.unfollow_explanation": "Jūs sekate šią paskyrą. Kad nebematytumėte jų įrašų savo pagrindiniame sraute, nebesekite.",
  "report_notification.attached_statuses": "Pridėti {count, plural, one {{count} įrašas} few {{count} įrašai} many {{count} įrašo} other {{count} įrašų}}",
  "report_notification.categories.legal": "Teisinės",
  "report_notification.categories.legal_sentence": "nelegalus turinys",
  "report_notification.categories.other": "Kita",
  "report_notification.categories.other_sentence": "kita",
  "report_notification.categories.spam": "Šlamštas",
  "report_notification.categories.spam_sentence": "šlamštas",
  "report_notification.categories.violation": "Taisyklės pažeidimas",
  "report_notification.categories.violation_sentence": "taisyklės pažeidimas",
  "report_notification.open": "Atidaryti ataskaitą",
  "search.clear": "Išvalyti paiešką",
  "search.no_recent_searches": "Nėra naujausių paieškų.",
  "search.placeholder": "Paieška",
  "search.quick_action.account_search": "Profiliai, atitinkantys {x}",
  "search.quick_action.go_to_account": "Eiti į profilį {x}",
  "search.quick_action.go_to_hashtag": "Eiti į saitažodį {x}",
  "search.quick_action.open_url": "Atidaryti URL adresą Mastodon",
  "search.quick_action.status_search": "Pranešimai, atitinkantys {x}",
  "search.search_or_paste": "Ieškoti arba įklijuoti URL",
  "search_popout.full_text_search_disabled_message": "Paieška {domain} įrašuose išjungta.",
  "search_popout.full_text_search_logged_out_message": "Pasiekiama tik prisijungus.",
  "search_popout.language_code": "ISO kalbos kodas",
  "search_popout.options": "Paieškos nustatymai",
  "search_popout.quick_actions": "Spartūs veiksmai",
  "search_popout.recent": "Naujausios paieškos",
  "search_popout.specific_date": "konkreti data",
  "search_popout.user": "naudotojas",
  "search_results.accounts": "Profiliai",
  "search_results.all": "Visi",
  "search_results.hashtags": "Grotažymės",
  "search_results.no_results": "Nėra rezultatų.",
  "search_results.no_search_yet": "Pabandykite ieškoti įrašų, profilių arba grotažymių.",
  "search_results.see_all": "Žiūrėti viską",
  "search_results.statuses": "Įrašai",
  "search_results.title": "Paieška užklausai „{q}“",
  "server_banner.about_active_users": "Žmonės, kurie naudojosi šiuo serveriu per pastarąsias 30 dienų (mėnesio aktyvūs naudotojai)",
  "server_banner.active_users": "aktyvūs naudotojai",
  "server_banner.administered_by": "Administruoja:",
  "server_banner.is_one_of_many": "{domain} – tai vienas iš daugelio nepriklausomų „Mastodon“ serverių, kuriuos gali naudoti fediverse.",
  "server_banner.server_stats": "Serverio statistika:",
  "sign_in_banner.create_account": "Sukurti paskyrą",
  "sign_in_banner.follow_anyone": "Sek bet kurį asmenį visoje fediverse ir žiūrėk viską chronologine tvarka. Jokių algoritmų, reklamų ar paspaudimų.",
  "sign_in_banner.mastodon_is": "„Mastodon“ – tai geriausias būdas sekti, kas vyksta.",
  "sign_in_banner.sign_in": "Prisijungti",
  "sign_in_banner.sso_redirect": "Prisijungti arba užsiregistruoti",
  "status.admin_account": "Atidaryti prižiūrėjimo sąsają @{name}",
  "status.admin_domain": "Atidaryti prižiūrėjimo sąsają {domain}",
  "status.admin_status": "Atidaryti šį įrašą prižiūrėjimo sąsajoje",
  "status.all_disabled": "Įrašo pasidalijimai ir komentavimai išjungti",
  "status.block": "Blokuoti @{name}",
  "status.bookmark": "Žymė",
  "status.cancel_reblog_private": "Nesidalinti",
  "status.cannot_quote": "Jums neleidžiama komentuoti šio įrašo",
  "status.cannot_reblog": "Šis įrašas negali būti pakeltas.",
  "status.contains_quote": "Turi komentarą",
  "status.context.loading": "Įkeliama daugiau atsakymų",
  "status.context.loading_error": "Nepavyko įkelti naujų atsakymų",
  "status.context.loading_success": "Įkelti nauji atsakymai",
  "status.context.more_replies_found": "Rasta daugiau atsakymų",
  "status.context.retry": "Kartoti",
  "status.context.show": "Rodyti",
  "status.continued_thread": "Tęsiama gijoje",
  "status.copy": "Kopijuoti nuorodą į įrašą",
  "status.delete": "Ištrinti",
  "status.delete.success": "Įrašas ištrintas",
  "status.detailed_status": "Išsami pokalbio peržiūra",
  "status.direct": "Privačiai paminėti @{name}",
  "status.direct_indicator": "Privatus paminėjimas",
  "status.edit": "Redaguoti",
  "status.edited": "Paskutinį kartą redaguota {date}",
  "status.edited_x_times": "Redaguota {count, plural, one {{count} kartą} few {{count} kartus} many {{count} karto} other {{count} kartų}}",
  "status.embed": "Gaukite įterpimo kodą",
  "status.favourite": "Pamėgti",
  "status.favourites_count": "{count, plural, one {{counter} patiko} few {{counter} patiko} many {{counter} patiko} other {{counter} patiko}}",
  "status.filter": "Filtruoti šį įrašą",
  "status.history.created": "{name} sukurta {date}",
  "status.history.edited": "{name} redaguota {date}",
  "status.load_more": "Krauti daugiau",
  "status.media.open": "Spausk, kad atidaryti",
  "status.media.show": "Spausk, kad matyti",
  "status.media_hidden": "Paslėpta medija",
  "status.mention": "Paminėti @{name}",
  "status.more": "Daugiau",
  "status.mute": "Nutildyti @{name}",
  "status.mute_conversation": "Nutildyti pokalbį",
  "status.open": "Išskleisti šį įrašą",
  "status.pin": "Prisegti prie profilio",
  "status.quote": "Komentuoti",
  "status.quote.cancel": "Atšaukti komentarą",
  "status.quote_error.blocked_account_hint.title": "Šis įrašas yra paslėptas, nes jūs esate užblokavę @{name}.",
  "status.quote_error.blocked_domain_hint.title": "Šis įrašas yra paslėptas, nes jūs užblokavote {domain}.",
  "status.quote_error.filtered": "Paslėpta dėl vieno iš jūsų filtrų",
  "status.quote_error.limited_account_hint.action": "Vis tiek rodyti",
  "status.quote_error.limited_account_hint.title": "Šis paskyra buvo paslėpta {domain} moderatorių.",
  "status.quote_error.muted_account_hint.title": "Šis įrašas yra paslėptas, nes jūs esate užtildę @{name}.",
  "status.quote_error.not_available": "Įrašas nepasiekiamas",
  "status.quote_error.pending_approval": "Įrašas peržiūrimas",
  "status.quote_error.pending_approval_popout.body": "„Mastodon“ galite kontroliuoti, ar kas nors gali jus cituoti (paminėti). Šis įrašas bus laukimo būsenoje, kol gausite originalaus įrašo autoriaus sutikimą.",
  "status.quote_error.revoked": "Autorius pašalino įrašą",
  "status.quote_followers_only": "Tik sekėjai gali cituoti šį įrašą",
  "status.quote_manual_review": "Autorius atskirai įvertins paskelbimą",
  "status.quote_noun": "Paminėjimas",
  "status.quote_policy_change": "Keisti, kas gali cituoti",
  "status.quote_post_author": "Paminėjo įrašą iš @{name}",
  "status.quote_private": "Privačių įrašų negalima komentuoti",
  "status.quotes.empty": "Šio įrašo dar niekas nepakomentavo. Kai kas nors tai padarys, jie bus rodomi čia.",
  "status.quotes.local_other_disclaimer": "Autoriaus atmesti įrašo komentavimai nebus rodomi.",
  "status.quotes.remote_other_disclaimer": "Čia bus rodoma tik komentavimai iš {domain}. Autoriaus atmesti įrašo komentavimai nebus rodomi.",
  "status.quotes_count": "{count, plural, one {{counter} komentaras} few {{counter} komentarai} many {{counter} komentarų} other {{counter} komentarai}}",
  "status.read_more": "Skaityti daugiau",
  "status.reblog": "Dalintis",
  "status.reblog_or_quote": "Dalintis arba komentuoti",
  "status.reblog_private": "Vėl pasidalinkite su savo sekėjais",
  "status.reblogged_by": "{name} pasidalino",
  "status.reblogs.empty": "Šiuo įrašu dar niekas nesidalino. Kai kas nors tai padarys, jie bus rodomi čia.",
  "status.reblogs_count": "{count, plural, one {{counter} pasidalinimas} few {{counter} pasidalinimai} many {{counter} pasidalinimų} other {{counter} pasidalinimai}}",
  "status.redraft": "Ištrinti ir parengti iš naujo",
  "status.remove_bookmark": "Pašalinti žymę",
  "status.remove_favourite": "Šalinti iš mėgstamų",
  "status.remove_quote": "Pašalinti",
  "status.replied_in_thread": "Atsakyta gijoje",
  "status.replied_to": "Atsakyta į {name}",
  "status.reply": "Atsakyti",
  "status.replyAll": "Atsakyti į giją",
  "status.report": "Pranešti apie @{name}",
  "status.request_quote": "Prašymas pakomentuoti",
  "status.revoke_quote": "Pašalinti mano įrašą iš @{name}’s įrašo",
  "status.sensitive_warning": "Jautrus turinys",
  "status.share": "Bendrinti",
  "status.show_less_all": "Rodyti mažiau visiems",
  "status.show_more_all": "Rodyti daugiau visiems",
  "status.show_original": "Rodyti originalą",
  "status.title.with_attachments": "{user} paskelbė {attachmentCount, plural, one {priedą} few {{attachmentCount} priedus} many {{attachmentCount} priedo} other {{attachmentCount} priedų}}",
  "status.translate": "Versti",
  "status.translated_from_with": "Išversta iš {lang} naudojant {provider}.",
  "status.uncached_media_warning": "Peržiūra nepasiekiama.",
  "status.unmute_conversation": "Atšaukti pokalbio nutildymą",
  "status.unpin": "Atsegti iš profilio",
  "subscribed_languages.lead": "Po pakeitimo tavo pagrindinėje ir sąrašo laiko skalėje bus rodomi tik įrašai pasirinktomis kalbomis. Jei nori gauti įrašus visomis kalbomis, pasirink nė vieno.",
  "subscribed_languages.save": "Išsaugoti pakeitimus",
  "subscribed_languages.target": "Keisti prenumeruojamas kalbas {target}",
  "tabs_bar.home": "Pagrindinis",
  "tabs_bar.menu": "Meniu",
  "tabs_bar.notifications": "Pranešimai",
  "tabs_bar.publish": "Naujas įrašas",
  "tabs_bar.search": "Paieška",
  "terms_of_service.effective_as_of": "Įsigaliojo nuo {date}.",
  "terms_of_service.title": "Paslaugų sąlygos",
  "terms_of_service.upcoming_changes_on": "Numatomi pakeitimai {date}.",
  "time_remaining.days": "liko {number, plural, one {# diena} few {# dienos} many {# dienos} other {# dienų}}",
  "time_remaining.hours": "liko {number, plural, one {# valanda} few {# valandos} many {# valandos} other {# valandų}}",
  "time_remaining.minutes": "liko {number, plural, one {# minutė} few {# minutės} many {# minutės} other {# minučių}}",
  "time_remaining.moments": "liko akimirkos",
  "time_remaining.seconds": "liko {number, plural, one {# sekundė} few {# sekundės} many {# sekundės} other {# sekundžių}}",
  "trends.counter_by_accounts": "{count, plural, one {{counter} žmogus} few {{counter} žmonės} many {{counter} žmogus} other {{counter} žmonių}} per {days, plural, one {dieną} few {{days} dienas} many {{days} dienas} other {{days} dienų}}",
  "trends.trending_now": "Tendencinga dabar",
  "ui.beforeunload": "Jei paliksi Mastodon, tavo juodraštis bus prarastas.",
  "units.short.billion": "{count} mlrd.",
  "units.short.million": "{count} mln.",
  "units.short.thousand": "{count} tūkst.",
  "upload_area.title": "Nuvilk, kad įkeltum",
  "upload_button.label": "Pridėti vaizdų, vaizdo įrašą arba garso failą",
  "upload_error.limit": "Viršyta failo įkėlimo riba.",
  "upload_error.poll": "Failų įkėlimas neleidžiamas su apklausomis.",
  "upload_error.quote": "Komentuojant įrašą failo įkėlimas negalimas.",
  "upload_form.drag_and_drop.instructions": "Kad paimtum medijos priedą, paspausk tarpo arba įvedimo klavišą. Tempant naudok rodyklių klavišus, kad perkeltum medijos priedą bet kuria kryptimi. Dar kartą paspausk tarpo arba įvedimo klavišą, kad nuleistum medijos priedą naujoje vietoje, arba paspausk grįžimo klavišą, kad atšauktum.",
  "upload_form.drag_and_drop.on_drag_cancel": "Nutempimas buvo atšauktas. Medijos priedas {item} buvo nuleistas.",
  "upload_form.drag_and_drop.on_drag_end": "Medijos priedas {item} buvo nuleistas.",
  "upload_form.drag_and_drop.on_drag_over": "Medijos priedas {item} buvo perkeltas.",
  "upload_form.drag_and_drop.on_drag_start": "Paimtas medijos priedas {item}.",
  "upload_form.edit": "Redaguoti",
  "upload_progress.label": "Įkeliama...",
  "upload_progress.processing": "Apdorojama…",
  "username.taken": "Šis naudotojo vardas užimtas. Pabandyk kitą.",
  "video.close": "Uždaryti vaizdo įrašą",
  "video.download": "Atsisiųsti failą",
  "video.exit_fullscreen": "Išeiti iš viso ekrano",
  "video.expand": "Išplėsti vaizdo įrašą",
  "video.fullscreen": "Visas ekranas",
  "video.hide": "Slėpti vaizdo įrašą",
  "video.mute": "Išjungti garsą",
  "video.pause": "Pristabdyti",
  "video.play": "Leisti",
  "video.skip_backward": "Praleisti atgal",
  "video.skip_forward": "Praleisti į priekį",
  "video.unmute": "Atšaukti nutildymą",
  "video.volume_down": "Patildyti",
  "video.volume_up": "Pagarsinti",
  "visibility_modal.button_title": "Nustatyti matomumą",
  "visibility_modal.direct_quote_warning.text": "Jei išsaugosite dabartinius nustatymus, įterptas (embeded) komentaras bus konvertuotas į nuorodą.",
  "visibility_modal.direct_quote_warning.title": "Komentarai negali būti įterpiami į privačius paminėjimus",
  "visibility_modal.header": "Matomumas ir sąveika",
  "visibility_modal.helper.direct_quoting": "Privatūs paminėjimai su žyma @, parašyti platformoje „Mastodon“, negali būti komentuojami kitų.",
  "visibility_modal.helper.privacy_editing": "Matomumo nustatymai negali būti keičiami po to, kai įrašas yra paskelbtas.",
  "visibility_modal.helper.privacy_private_self_quote": "Prie privataus įrašo tavo pridėti komentarai negali būti skelbiami viešai.",
  "visibility_modal.helper.private_quoting": "Tik sekėjams skirti įrašai, parašyti platformoje „Mastodon“, negali būti komentuojami kitų.",
  "visibility_modal.helper.unlisted_quoting": "Kai žmonės jus komentuoja, jų įrašai taip pat bus paslėpti iš populiariausių naujienų srauto.",
  "visibility_modal.instructions": "Kontroliuokite, kas gali bendrauti su šiuo įrašu. Taip pat galite taikyti nustatymus visiems būsimiems įrašams, pereidami į <link>Preferences > Posting defaults</link>.",
  "visibility_modal.privacy_label": "Matomumas",
  "visibility_modal.quote_followers": "Tik sekėjai",
  "visibility_modal.quote_label": "Kas gali komentuoti",
  "visibility_modal.quote_nobody": "Tik aš",
  "visibility_modal.quote_public": "Visi",
  "visibility_modal.save": "Išsaugoti"
}
